import { render, staticRenderFns } from "./legal-team-case-manage.vue?vue&type=template&id=55d5ad7d&scoped=true"
import script from "./legal-team-case-manage.vue?vue&type=script&lang=ts"
export * from "./legal-team-case-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d5ad7d",
  null
  
)

export default component.exports